import { Component } from 'react';
import { compose, withProps } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    mixEnabled as mixEnabledSelector,
    newCheckoutFlagData as newCheckoutFlagDataSelector,
    newCheckoutVariants,
} from 'ggApp/modules/featureFlag';
import flowNames from 'ggApp/modules/newCheckout/constants/flowNames';

class CheckoutErrorBoundary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    componentDidCatch(error, errorInfo) {
        const { errorAttributes, checkoutFlow, mixEnabled } = this.props;
        if (__DEVELOPMENT__) {
            console.error(error);
            console.error(errorInfo);
            return;
        }

        this.setState({
            hasError: true,
        });
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            return null;
        }

        return children;
    }
}

CheckoutErrorBoundary.propTypes = {
    children: PropTypes.node,
    errorAttributes: PropTypes.shape({}),
    checkoutFlow: PropTypes.string.isRequired,
    mixEnabled: PropTypes.bool.isRequired,
};

CheckoutErrorBoundary.defaultProps = {
    errorAttributes: {},
    children: null,
};

const enhanced = compose(
    connect(
        createStructuredSelector({
            checkoutFlag: newCheckoutFlagDataSelector,
            mixEnabled: mixEnabledSelector,
        }),
        null,
    ),
    withProps(({ checkoutFlag }) => ({
        checkoutFlow:
            checkoutFlag && checkoutFlag.variantKey === newCheckoutVariants.withHomeAddress
                ? flowNames.CHECKOUT_WITH_HOME_ADDRESS
                : flowNames.CHECKOUT_NO_HOME_ADDRESS,
    })),
)(CheckoutErrorBoundary);

export { enhanced as CheckoutErrorBoundary };
